import { Collapse } from '@mui/material';
import { TimelineContainer } from './TimelineContainer';
import { TimelineContent } from './TimelineContent';
import { useTimelineExpandedState } from 'app/agriculture/AgTimeline/context/TimelineContext';
import { TimelineAxis } from 'app/agriculture/AgTimeline/components/TimelineAxis/TimelineAxis';
import { TimelineScrubber } from 'app/agriculture/AgTimeline/components/TimelineScrubber/TimelineScrubber';
import { TimelineTimeLabel } from 'app/agriculture/AgTimeline/components/TimelineTimeLabel/TimelineTimeLabel';
import { TimelineRows } from 'app/agriculture/AgTimeline/components/TimelineRows/TimelineRows';
import { TimescaleControl } from 'app/agriculture/AgTimeline/components/TimescaleControl/TimescaleControl';

export function AgTimeline() {
    const isTimelineExpanded = useTimelineExpandedState();

    return (
        <TimelineContainer>
            <Collapse in={isTimelineExpanded}>
                <TimescaleControl />
            </Collapse>
            <TimelineContent>
                <TimelineAxis />
                <TimelineScrubber condensed={!isTimelineExpanded} />
                <TimelineContent.Header>
                    <TimelineTimeLabel />
                </TimelineContent.Header>
                <Collapse mountOnEnter unmountOnExit in={isTimelineExpanded}>
                    <TimelineRows />
                </Collapse>
            </TimelineContent>
        </TimelineContainer>
    );
}
